import { ThreeProvider } from './../../providers/three/three';
import { Dock } from './../../models/Dock';
import { AppFacade } from './../../facade/app.facade';
import { Component, ElementRef, Output, EventEmitter, ChangeDetectorRef, OnInit } from '@angular/core';

import 'rxjs/add/operator/first';
import { Subject } from 'rxjs';
import { take } from 'rxjs/operators';
import { Events } from 'ionic-angular';

/**
 * Generated class for the BuildingPlanComponent component.
 *
 * See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
 * for more info on Angular Components.
 */
@Component({
  selector: 'building-plan',
  templateUrl: 'building-plan.html'
})
export class BuildingPlanComponent implements OnInit {

  @Output('clicked') clickedDock: EventEmitter<any> = new EventEmitter()

  docks$ = this.facade.docks$;
  loaded$ = this.facade.loaded$;
  el: any;

  private destroy$ = new Subject()

  constructor(
    public facade: AppFacade,
    public element: ElementRef,
    private player: ThreeProvider,
    private ref: ChangeDetectorRef,
    private events: Events
  ) {
  }

  ngOnInit() { 
    this.loadData()
  }

  toggleColor(dock) {
    this.player.toggle(dock);
  }


  loadData() {
    this.player.setMainEl(this.element.nativeElement);
    this.player.setElement(this.element);
    this.player.loadAll()

    this.facade.loaded$.takeUntil(this.destroy$).subscribe((loaded) => {
      setTimeout(()=> {
        this.docks$.pipe(take(1)).subscribe((docks: Array<Dock>) => {
          docks.forEach((dock) => {
            this.toggleColor(dock);
          })

          this.ref.markForCheck();
        })
      }, 1000);

      this.player.clickListener.subscribe((uuid: String) => {
        this.facade.getDockByUuid(uuid).first().subscribe((res: Dock) => {
          this.clickedDock.emit(res)
        })
      })
    })

    this.facade.dockUpdated.subscribe((dock) => {
      this.events.publish('dock:updated', dock);
    });

    this.events.subscribe('dock:updated', (dock) => {
      this.toggleColor(dock);
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}



// WEBPACK FOOTER //
// ./src/components/building-plan/building-plan.ts